module.exports = __webpack_public_path__ + "img/ai-mobile.dfcd3b51.dfcd3b51.gif";